import React from 'react';
import { useTranslate } from 'lib/translate';
import moment from 'moment';
import { Spinner } from 'UI';
import { getActiveLanguage } from '@haldor/ui';

var SelectionDisplay = function SelectionDisplay(props) {
  var translate = useTranslate();

  if (props.start == null || props.end == null) {
    return null;
  }

  if (props.view == 'month') {
    return /*#__PURE__*/React.createElement("div", {
      className: "df aic selection-display"
    }, /*#__PURE__*/React.createElement("h3", {
      style: {
        marginBottom: '.75rem',
        marginTop: 0
      }
    }, moment(props.date).locale(getActiveLanguage()).format('MMMM')), props.isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : null);
  }

  if (moment(props.end).diff(moment(props.start), 'days') > 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "df aic selection-display"
    }, /*#__PURE__*/React.createElement("h3", {
      style: {
        marginBottom: '.75rem',
        marginTop: 0
      }
    }, translate('week'), " ", moment(props.date).format('W')), props.isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : null);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "df aic selection-display"
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      marginBottom: '.75rem',
      marginTop: 0
    }
  }, moment(props.date).format('dddd D MMMM').capitalize()), props.isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : null);
};

export default SelectionDisplay;